<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'devicegroup',
})
</script>
<template>
  <a-card title="仓库管理">
    <template  #extra>
        <lanseed-form-only ref="form" :data="searchVal" :rules="searchRule" :mode="false" @change="search">
          <template  #btn>
              <a-form-item>
              <a-button type="primary" v-if="auth.creating>0" @click="add"><PlusOutlined /> 新增设备组 </a-button>
            </a-form-item>
          </template>
        </lanseed-form-only>
    </template>
    <a-table :dataSource="dataSource" :pagination="page"
    :loading="loading" :columns="columns" @change="pageChange" >
    <template #bodyCell="{ column, record,index }">
      <template v-if="column.key === 'operation'">
        <a-button-group>
            <a-button v-if="auth.edit"  size="small" type="primary" @click="edit(record)">
                <EditOutlined /> 修改
            </a-button>
          </a-button-group>
      </template>
    </template>
    </a-table>
    <lanseed-form v-model:open="formshow" :data="formModel" :rules="formRole"  @change="submit"></lanseed-form>
  </a-card>
</template>

<script setup lang="ts" name="devicegroup">
import api from '@/utils/http/service'
import LanseedFormOnly from '@/components/lanseed/formonly.vue'
import LanseedForm from '@/components/lanseed/form.vue'
import detail from './detail.vue'
import {onMounted,defineProps,ref,watch,reactive,createVNode,defineComponent} from 'vue'
import { PlusOutlined,EditOutlined,DeleteOutlined,ContainerOutlined} from '@ant-design/icons-vue'

import { AutoData } from '@/utils/util'

  const auth:any=api.auth()
  const datamodel=ref<any>()//原始数据类型
  onMounted(()=>{
    api.devicegroup.model().then(res=>{
      if(res.state==1){
        datamodel.value=AutoData.InitModel(res.data)
        columns.value=AutoData.GetTableModel(datamodel.value,['ID','DeviceGroupName','FullWeight','EnumInfo'])
        var role=AutoData.GetFormModel(datamodel.value,['DeviceGroupName','EnumInfo','FullWeight'])
        role.DeviceGroupName.required=true
        role.FullWeight.required=true
        role.FullWeight.domtype="number"
        formRole.value=role
        getList()
      }
    })
  })

const searchVal:Record=ref({
  keyword:'',
})
const searchRule:Record=ref({
  keyword:{name:'关键字'}
})
const columns=ref<Array<object>>()
const page=ref<PageData>({
    current:1,
    pageSize:10,
    pageFlag:true,
    total:0,
    pageStatus:'more',
    currentKey: 'pageIndex',
    pageSizeKey: 'pageSize',
  })
  const search=(e):void=>{
    searchVal.value=e
    page.value.current=1
    getList()
  }
  const loading=ref<boolean>(false)
  const dataSource=ref<Array<any>>([])
  const getList=():void=>{
    loading.value=true
      api.devicegroup.list({pageIndex:page.value.current,pageSize:page.value.pageSize,...searchVal}).then(res => {
        loading.value=false
        if(res.state==1){
            dataSource.value=res.data.data
        page.value.total=res.data.records
        page.value.current=res.data.pageIndex
        }
      })
  }
  const pageChange=(e:anly)=>{
    page.value=e
    getList()
  }

const formModel:Record=ref({})
const formRole=ref({})
const formshow=ref<Boolean>(false)
const edit=(d)=>{
  formModel.value=AutoData.GetDefaltModel(datamodel.value,d)
  formshow.value=true
}
const add=()=>{
  formModel.value=AutoData.GetDefaltModel(datamodel.value,{DeviceTypeEnum:1,AutoStart:1,ID:0})
  formshow.value=true
}
const submit=(e:any)=>{
  api.devicegroup.add(e).then(res=>{
    if(res.state==1){
      formshow.value=false
      getList()
    }
  })
}
</script>
